import { Routes } from '@angular/router';
import { authGuard, CoreComponent, redirectToAccountIfLoggedInGuard, WwwRouteSlug } from '@pro-connect/shared';
import { AppSettings } from '@www/app.settings';

export const WWW_TITLE = 'PRO.CONNECT -';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: CoreComponent,
    children: [
      {
        path: '',
        canActivate: [redirectToAccountIfLoggedInGuard],
        loadComponent: () => import('@pro-connect/shared').then(({ HomeComponent }) => HomeComponent),
        title: `${WWW_TITLE} Strona główna`,
      },
      {
        path: WwwRouteSlug.LOGIN,
        title: `${WWW_TITLE} Zaloguj się`,
        canActivate: [redirectToAccountIfLoggedInGuard],
        loadComponent: () => import('@pro-connect/shared').then(({ LoginComponent }) => LoginComponent),
      },
      {
        path: `${WwwRouteSlug.ACTIVATE_ACCOUNT}/:token`,
        title: `${WWW_TITLE} Aktywuj konto`,
        canActivate: [redirectToAccountIfLoggedInGuard],
        loadComponent: () =>
          import('@pro-connect/shared').then(({ ActivateAccountComponent }) => ActivateAccountComponent),
      },
      {
        path: WwwRouteSlug.RESET_PASSWORD,
        title: `${WWW_TITLE} Zresetuj hasło`,
        canActivate: [redirectToAccountIfLoggedInGuard],
        loadComponent: () => import('@pro-connect/shared').then(({ ResetPasswordComponent }) => ResetPasswordComponent),
      },
      {
        path: `${WwwRouteSlug.CHANGE_PASSWORD}/:token`,
        title: `${WWW_TITLE} Zmień hasło`,
        canActivate: [redirectToAccountIfLoggedInGuard],
        loadComponent: () =>
          import('@pro-connect/shared').then(({ ChangeForgotPasswordComponent }) => ChangeForgotPasswordComponent),
      },
      {
        path: WwwRouteSlug.CONTACT,
        title: `${WWW_TITLE} Kontakt`,
        loadComponent: () => import('@pro-connect/shared').then(({ ContactComponent }) => ContactComponent),
      },
      {
        path: WwwRouteSlug.PRO_EDUCATION,
        title: `${WWW_TITLE} Pro Education`,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@pro-connect/shared').then(({ ProEducationPillarComponent }) => ProEducationPillarComponent),
          },
          {
            path: ':slug',
            loadComponent: () =>
              import('@pro-connect/shared').then(({ ProEducationTrainingComponent }) => ProEducationTrainingComponent),
          },
        ],
      },
      {
        path: WwwRouteSlug.PRO_EXPERIENCE,
        title: `${WWW_TITLE} Pro Experience`,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@pro-connect/shared').then(({ ProExperiencePillarComponent }) => ProExperiencePillarComponent),
          },
          {
            path: ':slug',
            loadComponent: () =>
              import('@pro-connect/shared').then(({ ProExperienceEventComponent }) => ProExperienceEventComponent),
          },
        ],
      },
      {
        path: WwwRouteSlug.PRO_SUPPORT,
        title: `${WWW_TITLE} Pro Support`,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@pro-connect/shared').then(({ ProSupportPillarComponent }) => ProSupportPillarComponent),
          },
        ],
      },
      {
        path: WwwRouteSlug.ABOUT_US,
        title: `${WWW_TITLE} O PRO.Connect`,
        loadComponent: () => import('@pro-connect/shared').then(({ AboutUsComponent }) => AboutUsComponent),
      },
      {
        path: `${WwwRouteSlug.BRAND}/:brand`,
        title: `${WWW_TITLE} Brand`,
        loadComponent: () => import('@pro-connect/shared').then(({ BrandComponent }) => BrandComponent),
      },
      {
        path: WwwRouteSlug.MADRID,
        loadComponent: () => import('@pro-connect/shared').then(({ MadridComponent }) => MadridComponent),
      },
      {
        path: WwwRouteSlug.SINGAPUR,
        loadComponent: () => import('@pro-connect/shared').then(({ SingapurComponent }) => SingapurComponent),
      },
      {
        path: WwwRouteSlug.PRIVACY_POLICY,
        title: `${WWW_TITLE} Polityka prywatności`,
        loadComponent: () => import('@pro-connect/shared').then(({ PrivacyPolicyComponent }) => PrivacyPolicyComponent),
      },
      {
        path: WwwRouteSlug.COOKIES_POLICY,
        title: `${WWW_TITLE} Polityka plików cookies`,
        loadComponent: () => import('@pro-connect/shared').then(({ CookiesPolicyComponent }) => CookiesPolicyComponent),
      },
      {
        path: `${WwwRouteSlug.EVENT_TICKET}`,
        title: `${WWW_TITLE} Potwierdż obecność na wydarzeniu`,
        loadComponent: () => import('@pro-connect/shared').then(({ EventTicketComponent }) => EventTicketComponent),
      },
      {
        path: WwwRouteSlug.ACCOUNT,
        canActivate: [authGuard],
        loadComponent: () => import('@pro-connect/shared').then(({ AccountComponent }) => AccountComponent),
        children: [
          {
            path: '',
            title: `${WWW_TITLE} Strona główna`,
            loadComponent: () => import('@pro-connect/shared').then(({ HomeComponent }) => HomeComponent),
          },
          {
            path: WwwRouteSlug.MY_DATA,
            title: `${WWW_TITLE} Twoje konto`,
            loadComponent: () => import('@pro-connect/shared').then(({ MyDataComponent }) => MyDataComponent),
          },
          // Why duplicated route -> one is domain/pro-education and another one is in children /account
          {
            path: WwwRouteSlug.PRO_EDUCATION,
            title: `${WWW_TITLE} Pro Education`,
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('@pro-connect/shared').then(({ ProEducationComponent }) => ProEducationComponent),
              },
              {
                path: ':slug',
                loadComponent: () =>
                  import('@pro-connect/shared').then(
                    ({ ProEducationTrainingComponent }) => ProEducationTrainingComponent,
                  ),
              },
            ],
          },
          // Why duplicated route -> one is domain/pro-experience and another one is in children /account
          {
            path: WwwRouteSlug.PRO_EXPERIENCE,
            title: `${WWW_TITLE} Pro Experience`,
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('@pro-connect/shared').then(({ ProExperienceComponent }) => ProExperienceComponent),
              },
              {
                path: ':slug',
                loadComponent: () =>
                  import('@pro-connect/shared').then(({ ProExperienceEventComponent }) => ProExperienceEventComponent),
              },
            ],
          },
          {
            path: WwwRouteSlug.ORDERS,
            title: `${WWW_TITLE} Zamówienia`,
            loadComponent: () => import('@pro-connect/shared').then(({ OrdersComponent }) => OrdersComponent),
          },
        ],
      },
      {
        path: '**',
        loadComponent: () => import('@pro-connect/shared').then(({ NotFoundPageComponent }) => NotFoundPageComponent),
        title: `${AppSettings.TITLE_PREFIX} - 404`,
      },
    ],
  },
];
